import { ModelApiService } from './BaseApiService'

export default class TasksApiService extends ModelApiService {
  constructor() {
    super('tasks')
  }

  async getTaskDetails(taskId) {
    return await this.get(`${taskId}/dispute-follow-up/details`)
  }
}
